// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { ProfileRef, ProfileRefT } from '../tbs/profile-ref.js';


export class InvitePlayerSlotAction implements flatbuffers.IUnpackableObject<InvitePlayerSlotActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):InvitePlayerSlotAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsInvitePlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:InvitePlayerSlotAction):InvitePlayerSlotAction {
  return (obj || new InvitePlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsInvitePlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:InvitePlayerSlotAction):InvitePlayerSlotAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new InvitePlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyInvitePlayerSlot;
}

profile(obj?:ProfileRef):ProfileRef|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new ProfileRef()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startInvitePlayerSlotAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyInvitePlayerSlot);
}

static addProfile(builder:flatbuffers.Builder, profileOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, profileOffset, 0);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(2, playerId, 0);
}

static endInvitePlayerSlotAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): InvitePlayerSlotActionT {
  return new InvitePlayerSlotActionT(
    this.type(),
    (this.profile() !== null ? this.profile()!.unpack() : null),
    this.playerId()
  );
}


unpackTo(_o: InvitePlayerSlotActionT): void {
  _o.type = this.type();
  _o.profile = (this.profile() !== null ? this.profile()!.unpack() : null);
  _o.playerId = this.playerId();
}
}

export class InvitePlayerSlotActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyInvitePlayerSlot,
  public profile: ProfileRefT|null = null,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const profile = (this.profile !== null ? this.profile!.pack(builder) : 0);

  InvitePlayerSlotAction.startInvitePlayerSlotAction(builder);
  InvitePlayerSlotAction.addType(builder, this.type);
  InvitePlayerSlotAction.addProfile(builder, profile);
  InvitePlayerSlotAction.addPlayerId(builder, this.playerId);

  return InvitePlayerSlotAction.endInvitePlayerSlotAction(builder);
}
}
